// Module
var code = `<div class="flex flex-nowrap gap-0.5"> <span ng-repeat="state in states" ng-class="[stateWidthClass(), {'bg-harvustorange/50': isAfter(state)}]" class="bg-harvustorange h-2 rounded-xs" ui-state="state"></span> </div> `;
// Exports
export default code;